import API from '../api';

export const getCeleryFile = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/aichatbot/task_status/${uuid}/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error');
        });
    } catch (error) {
      reject('system error');
    }
  });
};

export const downloadCeleryFile = async (url) => {
  const response = await API.get(url, { responseType: 'blob' });
  const disposition = response.headers?.['content-disposition'] || '';
  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  return {
    blob: response.data,
    filename: filenameMatch?.[1] || 'student-responses.xlsx',
  };
};
